import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import supportedLanguages from '@ari-app/locales/languages.json'

const getSupportedLanguages = () => {
	const langList = [];
	for (const [key] of Object.entries(supportedLanguages)) {
		let lang = key.replace('_', '-');
		if (langList.indexOf(lang) === -1) {
			langList.push(lang);
		}

		lang = lang.split('-')[0];
		if (langList.indexOf(lang) === -1) {
			langList.push(lang);
		}

	}

	return langList;
}

i18n
		.use(Backend)
		.use(LanguageDetector)
		.use(initReactI18next)
		.init({
			      load: 'all',
			      debug: false,
			      supportedLngs: getSupportedLanguages(),

			      fallbackLng: ['fr'],
			      //detection: {caches: false,},


			      backend: {
				      loadPath: '/locales/{{lng}}/{{ns}}.json',
				      crossDomain: false,
				      allowMultiLoading: false
			      },

			      interpolation: {
				      escapeValue: false, // not needed for react as it escapes by default
			      },

			      ns: ["global"],
			      defaultNS: "global",
			      keySeparator: ".",
			      nsSeparator: false,
		      });

// i18n.resolvedLanguage

export default i18n;
